import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../shared/environments/environment';
import { Observable, share } from 'rxjs';
import { Params } from '@angular/router';
import { IPaginatedResponse } from '../typing/response.interface';
import { IGroup, IGroupCreate, IGroupUpdate } from '../typing/group.interface';

@Injectable({
    providedIn: 'root'
})
export class GroupsService {

    currentGroupId = signal<number | null>(null);

    constructor(private http: HttpClient) {
    }

    getGroups(query: Params): Observable<IPaginatedResponse<IGroup>> {
        return this.http.get<IPaginatedResponse<IGroup>>(`${environment.API_BASE_PATH}/groups`, {params: query});
    }

    getGroup(id: number): Observable<IGroup> {
        return this.http.get<IGroup>(`${environment.API_BASE_PATH}/group/${id}`).pipe(share());
    }

    deleteGroups(data: number[]): Observable<void> {
        return this.http.delete<void>(`${environment.API_BASE_PATH}/groups`, {
            body: data
        });
    }

    createGroup(group: IGroupCreate): Observable<IGroup> {
        return this.http.post<IGroup>(`${environment.API_BASE_PATH}/group`, group);
    }

    updateGroup(group: IGroupUpdate): Observable<IGroup> {
        return this.http.put<IGroup>(`${environment.API_BASE_PATH}/group/${group.id}`, group);
    }

}
